@let confirmationDialog =
  currentRendering.subfeatures.actions.selectors.confirmationDialog.asSignal();
@let confirmationDialogTitle =
  currentRendering.subfeatures.actions.selectors.confirmationDialogTitle.asSignal();
@let confirmationDialogMessage =
  currentRendering.subfeatures.actions.selectors.confirmationDialogMessage.asSignal();

@if (confirmationDialog) {
  <atn-ds-centered-overlay type="confirmation">
    <div class="confirmation-dialog">
      <atn-ds-widget [title]="confirmationDialogTitle">
        <div actions>
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelClickHandler()"
          ></i>
        </div>
        <div class="confirmation-dialog__widget-content">
          {{ confirmationDialogMessage }}
        </div>
        <div
          footer
          class="confirmation-dialog__footer"
        >
          <atn-ds-button
            type="transparent"
            (click)="cancelClickHandler()"
            >Cancel</atn-ds-button
          >
          <atn-ds-button (click)="confirmClickHandler()">Confirm</atn-ds-button>
        </div>
      </atn-ds-widget>
    </div>
  </atn-ds-centered-overlay>
}
